import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box, Flex, Small } from "orcs-design-system";
import { Link } from "react-router-dom";
import TeamAvatar from "src/components/TeamAvatar/TeamAvatar";
import { teamDetailsPath } from "src/util/routing";

const ScrollableList = styled(Box)`
  max-height: 200px;
  overflow-y: auto;
`;

const TeamNameLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.greyDarkest};
  font-weight: 500;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const LinkedTeamsPopoverContent = ({ teams }) => {
  if (!teams?.length) {
    return null;
  }

  return (
    <ScrollableList>
      {teams.map((team) => (
        <Flex key={team.id} alignItems="center" gap="s" py="xs">
          <TeamAvatar group={team} customSize="24px" />
          <TeamNameLink to={teamDetailsPath(team)}>
            <Small>{team.name}</Small>
          </TeamNameLink>
        </Flex>
      ))}
    </ScrollableList>
  );
};

LinkedTeamsPopoverContent.propTypes = {
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default LinkedTeamsPopoverContent;
